import React, { useState, useEffect } from 'react';
import {
  Button,
  Paper,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ChatIcon from '@mui/icons-material/Chat';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import Loading from 'components/Utils/loading';
import DialogEnviarMensagem from 'app/routes/cobranca/Mensagens/dialogEnviarMensagem';
import { useSelector } from 'react-redux';
import SnackbarNotification from 'components/SnackbarNotification';

import api from 'services/api';

const DialogDetalhesMensagem = ({
  open,
  onClose,
  mensagem,
  tab = 'RECEBIDOS',
  onMarcarComoLido,
  showMarcarComoLido = true,
  onDeletarMensagem,
  showDeletarMensagem = false,
  showResponderMensagem = true,
}) => {

  const authUserId = useSelector(({ auth }) => auth.authUserInfo?.id);

  const [openDialogMensagem, setOpenDialogMensagem] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listaDestinatarios, setListaDestinatarios] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertInfo, setAlertInfo] = useState();
  const [alertInfoTipo, setAlertInfoTipo] = useState();
  const [destinatarioResponder, setDestinatarioResponder] = useState(null);
  const [mensagemAtual, setMensagemAtual] = useState(null);

  const handleClickCloseAlert = () => setOpenAlert(false);

  useEffect(() => {
    setMensagemAtual(mensagem || null);
  }, [mensagem, open]);

  useEffect(() => {
    if (open) {
      setLoading(true);
      const fetchDestinatarios = async () => {
        try {
          const response = await api.get('/colaboradores_mensagens');
          const destinatariosFiltrados = response.data.filter(dest => dest.id !== authUserId);
          setListaDestinatarios(destinatariosFiltrados);
        } catch (error) {
          setAlertInfo('Erro ao carregar destinatários.');
          setAlertInfoTipo('mb-3 bg-danger');
          setOpenAlert(true);
        } finally {
          setLoading(false);
        }
      };

      fetchDestinatarios();
    }
    if (!open) {
      setListaDestinatarios([]);
    }
  }, [open, authUserId]);

  const handleMarcarComoLido = () => {
    if (onMarcarComoLido && mensagemAtual) {
      onMarcarComoLido(mensagemAtual);
      onClose();
    }
  };

  const handleDeletarMensagem = () => {
    if (onDeletarMensagem && mensagemAtual) {
      onDeletarMensagem(mensagemAtual);
    }
  };

  function formatarData(data) {
    if (!data) return '';
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
      return data;
    }
    const d = new Date(data);
    if (!isNaN(d)) {
      return d.toLocaleDateString('pt-BR');
    }
    return '';
  }

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          Detalhes da Mensagem
          <IconButton
            aria-label="fechar"
            onClick={onClose}
            style={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {mensagemAtual && (
            <>
              <div
                style={{
                  marginBottom: 8,
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                }}
              >
                <b>Assunto:</b> {mensagemAtual.assunto}
              </div>
              <div style={{ marginBottom: 8 }}>
                <b>{tab === 'RECEBIDOS' ? 'De' : 'Para'}:</b> {mensagemAtual.pessoa || mensagemAtual.sender_name || mensagemAtual.receiver_name}
              </div>
              <div style={{ marginBottom: 8 }}>
                <b>Data:</b> {formatarData(mensagemAtual.data)} &nbsp;
              </div>
              <div style={{ marginBottom: 8 }}>
                <b>Hora:</b> {mensagemAtual.hora || ''}
              </div>
              <div style={{ marginBottom: 8 }}>
                <b>Status:</b> {mensagemAtual.lido === 'Sim' ? 'Lido' : 'Não lido'}
              </div>
              <div style={{ marginTop: 16 }}>
                <b>Mensagem:</b>
                <Paper
                  variant="outlined"
                  style={{ padding: 12, marginTop: 8, background: '#f9f9f9', wordBreak: 'break-all' }}
                  dangerouslySetInnerHTML={{
                    __html: (mensagemAtual.mensagem || mensagemAtual.obs || '').replace(/\n/g, '<br />')
                  }}
                />
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          {showResponderMensagem &&
            tab === 'RECEBIDOS' &&
            mensagemAtual && (
              <Button
                onClick={() => {
                  const destinatario = listaDestinatarios.find(
                    d => d.nome === (mensagemAtual.sender_name || mensagemAtual.pessoa)
                  );
                  setDestinatarioResponder(destinatario || null);
                  setOpenDialogMensagem(true);
                }}
                color="primary"
                variant="outlined"
                startIcon={<ChatIcon />}
              >
                Responder
              </Button>
            )}
          {showMarcarComoLido &&
            tab === 'RECEBIDOS' &&
            mensagemAtual &&
            mensagemAtual.lido === 'Não' && (
              <Button
                onClick={handleMarcarComoLido}
                color="primary"
                variant="outlined"
                startIcon={<MarkEmailReadIcon />}
              >
                Marcar como lido
              </Button>
            )}
          {showDeletarMensagem && mensagemAtual && (
            <Button
              onClick={handleDeletarMensagem}
              color="secondary"
              variant="outlined"
              startIcon={<DeleteIcon />}
              style={{ marginLeft: 8 }}
            >
              Excluir Mensagem
            </Button>
          )}
        </DialogActions>

        <DialogEnviarMensagem
          open={openDialogMensagem}
          onClose={() => {
            setOpenDialogMensagem(false);
            setDestinatarioResponder(null);
          }}
          listaDestinatarios={listaDestinatarios}
          loading={loading}
          destinatarioInicial={destinatarioResponder}
          mensagemParaMarcarComoLida={mensagemAtual}
          onMensagemMarcadaComoLida={(mensagemLida) => {
            setMensagemAtual(mensagemLida);
            if (onMarcarComoLido) onMarcarComoLido(mensagemLida);
          }}
          onFeedback={(msg, tipo) => {
            setAlertInfo(msg);
            setAlertInfoTipo(tipo);
            setOpenAlert(true);
          }}
        />

        <Loading carregar={loading} />
      </Dialog>
      <SnackbarNotification openAlert={openAlert} alertInfoTipo={alertInfoTipo} alertInfo={alertInfo} callbackParent={handleClickCloseAlert} />
    </>
  );
};

DialogDetalhesMensagem.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  mensagem: PropTypes.object,
  tab: PropTypes.string,
  onMarcarComoLido: PropTypes.func,
  showMarcarComoLido: PropTypes.bool,
};

export default DialogDetalhesMensagem;
